/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import {
	AsyncJSMOperationsHorizontalNav,
	LazyJSMOperationsHorizontalNav,
} from '@jira/navigation-apps__horizontal-nav-jsm-operations/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskOncallScheduleRoute } from '@jira/router-routes__servicedesk-oncall-routes/src/servicedeskOncallScheduleRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskOpsgenieSchedule, {
	LazyServicedeskOpsgenieSchedule,
} from './ui/opsgenie-schedule/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const servicedeskOncallScheduleRouteEntry: Route = createEntry(
	servicedeskOncallScheduleRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'service-management.on-call-schedule',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskOpsgenieSchedule,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncJSMOperationsHorizontalNav,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [
			LazyAtlassianNavigation,
			LazyServicedeskOpsgenieSchedule,
			LazyJSMOperationsHorizontalNav,
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
